import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const PriceColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: flex-start;
  align-items: flex-start;
  white-space: nowrap;
  ${p =>
    p.align === 'right' &&
    css`
      align-items: flex-end;
      text-align: right;
    `}
  ${media.smallOnly`
    max-width: 80px;
    > span {
      font-size: 1rem;
    }
  `}
`;

export const HideOnMobile = styled.div`
  ${media.smallOnly`
    display:none;
  `}
`;

export const Hidden = styled.span`
  display: none;
`;
